import { Component, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  BaseEntitySelectComponent,
  EntitySelectComponent,
  EntitySelectRowDirective,
} from '@shared/components/entity/select';
import { __ } from '@shared/functions';
import { GetAllFn } from '@shared/services/entity/entity.service';
import {
  Property as TEntity,
  PropertyFilter as TFilter,
  PropertySort as TSort,
} from '../../../../models/entity/property';
import { PropertiesService } from '../../../../services/entity/properties.service';
import { PropertyListCellComponent } from '../../list/cell/property/property-list-cell.component';

@Component({
  selector: 'backoffice-property-select',
  imports: [EntitySelectComponent, EntitySelectRowDirective, PropertyListCellComponent],
  templateUrl: './property-select.component.html',
})
export class PropertySelectComponent extends BaseEntitySelectComponent<TEntity, TFilter, TSort> {
  // -----------------------------------------------------------------------------------------------------
  // @ DEPENDENCIES
  // -----------------------------------------------------------------------------------------------------

  private readonly t = inject(TranslateService);

  private readonly entityService = inject(PropertiesService);

  // -----------------------------------------------------------------------------------------------------
  // @ INSTANCE VARIABLES
  // -----------------------------------------------------------------------------------------------------

  source: GetAllFn<TEntity, TFilter, TSort> = this.entityService.getAll.bind(this.entityService);

  override labelSelector = (entity: TEntity) =>
    __.IsNullOrUndefined(entity) ? '' : `${entity?.name}`;

  // street is the full addressLine1 incl. house number — houseNumber never comes from the api
  override subLabelSelector = (entity: TEntity) =>
    __.IsNullOrUndefined(entity)
      ? ''
      : `${entity?.address?.street}, ${entity?.address?.zipCode} ${entity?.address?.city}`;

  // -----------------------------------------------------------------------------------------------------
  // @ INPUT VARIABLES
  // -----------------------------------------------------------------------------------------------------

  override label = input<string>(this.t.instant('Property.Property'));

  override displayName = input<string>(this.t.instant('Property.Property'));

  override placeholder = input<string>(this.t.instant('Property.Search for properties'));

  override panelLabel = input<string>(this.t.instant('Property.Properties'));

  override notFoundText = input<string>(this.t.instant('Property.No properties found'));
}
